/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Syphon = require('backbone.syphon');
var Radio = require('backbone.radio');

var momentUtil = require('common/util/momentUtil');
var BreadcrumbView = require('common/views/BreadcrumbView');

var DepRiskMatrixFormView = require('./DepRiskMatrixFormView');

var SubmitEntityRiskMatrix = require('../services/SubmitEntityRiskMatrix');

var tmplDepRiskMatrixEditView = require('../templates/DepRiskMatrixEditView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepRiskMatrixEditView,

  className: 'dep-edit-risk-matrix-form-view container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    riskMatrixFormContainer: '.edit-risk-matrix-form-container',
    submit: '.btn-submit'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    riskMatrixFormContainer: '@ui.riskMatrixFormContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var entityIdentifiers = this.model.get('entityIdentifiers') || {};
    var entityId = entityIdentifiers.entityId;
    var entityName = entityIdentifiers.entityName;
    var riskMatrix = this.model.get('riskMatrix') || {};

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#dep/dashboard',
            text: 'Home'
          },
          {
            link: '#dep/entity/' + entityId + '/dashboard',
            text: entityName
          },
          {
            link: '#dep/entity/' + entityId + '/risk-matrix/' + riskMatrix.id + '/dashboard',
            text: riskMatrix.riskType + ' (' + riskMatrix.asOfDate + ')'
          },
          {
            text: 'Edit Risk Matrix'
          }
        ]
      })
    );

    this.riskMatrixForm = new DepRiskMatrixFormView({
      model: new Backbone.Model({
        riskMatrix: this.model.get('riskMatrix') || {},
        trackingLookups: this.model.get('trackingLookups') || {}
      })
    });

    this.showChildView('riskMatrixFormContainer', this.riskMatrixForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();

    var entityIdentifiers = this.model.get('entityIdentifiers');
    var riskMatrix = this.model.get('riskMatrix');

    var laddaContext = Ladda.create(e.currentTarget);
    this.riskMatrixForm.validate().done(
      function() {
        laddaContext.start();

        var formData = Syphon.serialize(this);
        formData.id = riskMatrix.id;

        formData.asOfDate = momentUtil.formatStr(formData.asOfDate, momentUtil.defaultOutboundDateConfig);
        formData.examStartDate = momentUtil.formatStr(formData.examStartDate, momentUtil.defaultOutboundDateConfig);
        formData.dateEntered = momentUtil.formatStr(formData.dateEntered, momentUtil.defaultOutboundDateConfig);
        formData.entityId = entityIdentifiers.entityId;

        SubmitEntityRiskMatrix(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:dp:risk-matrix', entityIdentifiers.entityId, riskMatrix.id);
          })
          .fail(function(err) {
            laddaContext.stop();
          });
      }.bind(this)
    );
  }
});
